<template>
  <div>
    <div class="card-title font-weight-bold">
      Contact Details
    </div>
    <hr class="mt-1 border-dark">

    <div class="form-group form-row mb-1">
      <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
             for="crewContactEmail"
      >EMAIL:</label>
      <div class="col col-sm-7">
        <input class="form-control form-control-xs form-display h-1x"
               type="text"
               id="crewContactEmail"
               v-model="crew.email"
               readonly
        >
      </div>

      <update-crew-email v-if="crew.id"></update-crew-email>

    </div>

    <div class="form-group form-row mb-1" v-for="crewContact in crew.crew_contacts" :key="crewContact.id">
      <label class="col col-sm-2 col-form-label font-weight-bolder text-left form-label-xs"
             :for="'crewContactNumber' + crewContact.id"
      >{{ crewContact.contact_type ? crewContact.contact_type.name : '' }}:</label>
      <div class="col col-sm-7">
        <input class="form-control form-control-xs form-display h-1x"
               type="text"
               :id="'crewContactNumber' + crewContact.id"
               v-model="crewContact.contact"
               readonly
        >
      </div>

      <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isSystemAdmin) && !guest && !isKline">
        <template v-if="crew.active == 1">

          <div class="col col-sm-2">
            <button class="btn btn-sm btn-xs"
                    data-toggle="modal" data-target="#editCrewContact"
                    title="Edit Crew Contact"
                    @click="updateEditCrewContactModal(crewContact)"
            >
              <span class="fas fa-edit"></span>
            </button>
            <button class="btn btn-sm btn-xs"
                    title="Remove this Contact"
                    @click="confirmDeleteCrewContact(crewContact.id)"
            >
              <span class="fas fa-minus text-danger"></span>
            </button>
          </div>
        </template>
      </template>

    </div>

    <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isSystemAdmin) && !guest && !isKline">
      <template v-if="crew.active == 1">
        <div class="form-group form-row">
          <div class="col col-sm-1 offset-9">
            <button class="btn btn-sm btn-xs"
                    title="Add Crew Contact"
                    data-toggle="modal" data-target="#newCrewContact"
            >
              <span class="fas fa-plus"></span>
            </button>
          </div>
        </div>
      </template>
    </template>

    <div class="modal fade" id="editCrewContact" tabindex="-1" role="dialog" aria-labelledby="editCrewContactTitle"
         aria-hidden="true" v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="confirmUpdateCrewContact">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="editCrewContactTitle">
              Edit Crew Contact
            </h5>
            <button type="button" id="closeEditCrewContact" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewContactErrors.contact_type_id}">
              <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="editContactType">
                Contact Type:
              </label>
              <div class="col col-sm-6">
                <select id="editContactType" required
                        class="form-control form-control-xs"
                        v-model="editCrewContact.contact_type_id"
                >
                  <option :value="null">--- Select Contact Type ---</option>
                  <option v-for="contactTypeKey in contactTypeKeys" :key="contactTypeKey.id"
                          :value="contactTypeKey.id"
                  >
                    {{ contactTypeKey.name }}
                  </option>
                </select>
                <span class="help-block" v-if="editCrewContactErrors.contact_type_id !== ''">
                                    <small><strong>{{ editCrewContactErrors.contact_type_id }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': editCrewContactErrors.contact}">
              <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="date_hired">
                {{editCrewContact.contact_type_id===8 ? 'Email:' : 'Contact:'}}
              </label>
              <div class="col col-sm-6">
                <input type="text" id="date_hired"
                       class="form-control form-control-xs"
                       v-model="editCrewContact.contact"
                >
                <span class="help-block" v-if="editCrewContactErrors.contact !== ''">
                                    <small><strong>{{ editCrewContactErrors.contact }}</strong></small>
                                </span>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-warning font-weight-bolder">
              <span class="fas fa-edit"></span>
              Update
            </button>
          </div>

        </form>
      </div>
    </div>

    <div class="modal fade" id="newCrewContact" tabindex="-1" role="dialog" aria-labelledby="newCrewContactTitle"
         aria-hidden="true" v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="confirmAddNewCrewContact">

          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="newCrewLanguageTitle">
              New Crew Contact
            </h5>
            <button type="button" id="closeNewCrewContact" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewContactErrors.contact_type_id}">
              <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="newContactType">
                Contact Type:
              </label>

              <div class="col col-sm-6">
                <select id="newContactType" required
                        class="form-control form-control-xs"
                        v-model="newCrewContact.contact_type_id"
                >
                  <option :value="null">--- CONTACT TYPE ---</option>
                  <option v-for="contactTypeKey in contactTypeKeys" :key="contactTypeKey.id"
                          :value="contactTypeKey.id"
                  >
                    {{ contactTypeKey.name }}
                  </option>
                </select>
                <span class="help-block" v-if="newCrewContactErrors.contact_type_id !== ''">
                                    <small><strong>{{ newCrewContactErrors.contact_type_id }}</strong></small>
                                </span>
              </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCrewContactErrors.contact}">
              <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="newContact">
                {{newCrewContact.contact_type_id===8 ? 'Email:' : 'Contact:'}}
              </label>

              <div class="col col-sm-6">
                <input type="text" id="newContact" required
                       class="form-control form-control-xs"
                       v-model="newCrewContact.contact"
                >
                <span class="help-block" v-if="newCrewContactErrors.contact !== ''">
                                    <small><strong>{{ newCrewContactErrors.contact }}</strong></small>
                                </span>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
              <span class="fas fa-plus"></span>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {gateMixin} from "@/mixins/gateMixin";

import UpdateCrewEmail
  from "@/components/sub_components/master_lists/crews/crew_show_components/crew_201/crew_contacts/UpdateCrewEmail";

export default {
  name: "ContactDetails",
  mixins: [vueAppMixin, formMixin, gateMixin],

  components: {UpdateCrewEmail},

  data() {
    return {
      editCrewContact: {},
      editCrewContactErrors: [],
      newCrewContact: {},
      newCrewContactErrors: [],
      editable: false
    }
  },

  methods: {
    ...mapActions(['getContactTypeKeys', 'updateCrewContact', 'addCrewContact', 'deleteCrewContact']),

    updateEditCrewContactModal(crewContact) {
      this.editCrewContact = Object.assign({}, crewContact);
      this.editCrewContactErrors = [];
    },

    refreshNewCrewContact() {
      this.newCrewContact = {crew_id: this.crew.id, contact_type_id: null, contact: '', active: true};
      this.newCrewContactErrors = [];
    },

    async confirmUpdateCrewContact() {
      if (await this.confirmUpdate()) {
        let params = {
          crewContactId: this.editCrewContact.id,
          contact_type_id: this.editCrewContact.contact_type_id,
          contact: this.editCrewContact.contact,
          active: this.editCrewContact.active
        };
        let updatedCrewContact = await this.updateCrewContact(params);
        if (updatedCrewContact) {
          if (updatedCrewContact.errors) {
            this.editCrewContactErrors = updatedCrewContact.errors;
          } else {
            this.successAlert('Crew Contact Successfully Updated', 'UPDATE');
            document.getElementById('closeEditCrewContact').click();
            this.editCrewContactErrors = [];
          }
        }
      }
    },

    async confirmAddNewCrewContact() {
      if (await this.confirmCreateAlert()) {
        let newCrewcontact = await this.addCrewContact(this.newCrewContact);
        if (newCrewcontact) {
          if (newCrewcontact.errors) {
            this.newCrewContactErrors = newCrewcontact.errors
          } else {
            this.successAlert('New Crew Contact Successfully Saved', 'CREATE');
            this.refreshNewCrewContact();
            document.getElementById('closeNewCrewContact').click();
          }
        }
      }
    },

    async confirmDeleteCrewContact(crewContactId) {
      if (await this.confirmDeleteAlert()) {
        if (await this.deleteCrewContact(crewContactId)) {
          this.successAlert('Crew Contact Successfully Deleted', 'DELETE');
        }
      }
    }

  },

  computed: {
    ...mapGetters(['crew', 'contactTypeKeys'])
  },

  mounted() {
    $('#newCrewContact').on('hidden.bs.modal',
        () => this.refreshNewCrewContact()
    )

    this.getContactTypeKeys();
    this.refreshNewCrewContact();
  }
}
</script>

<style scoped>

</style>
